var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _rect2, _path22, _rect3, _rect4, _polygon, _rect5, _polygon2, _polygon3, _polygon4, _rect6, _rect7, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 612 381.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ec2024;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#1d1d1d;}.cls-4{fill:#afafb0;}.cls-5{fill:url(#_\xC2\xC1_\xCF_\xCC\xCC_\xC8_\xCB\xC2\xCC\xDA_19);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 206.21,
    y1: 159.05,
    x2: 347.27,
    y2: 159.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec2024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb1d25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC2\\xC1_\\xCF_\\xCC\\xCC_\\xC8_\\xCB\\xC2\\xCC\\xDA_19",
    x1: 38.53,
    y1: 190.93,
    x2: 183.11,
    y2: 190.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ed2830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ed2830"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.46,151.64h-8.25l1.23-6h24.07l-1.23,6h-8.22l-4.18,20.85h-7.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.21,164.42l4.57,8.07h-7.95l-4-7.14H238l-1.42,7.14H229l5.37-26.88h11.48c6.87,0,10.83,3.19,10.83,8.56A10.38,10.38,0,0,1,249.21,164.42Zm-4.45-12.82h-4l-1.61,7.87h4.53c3.34,0,5.3-1.61,5.3-4.57C249,152.64,247.37,151.6,244.76,151.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.74,167.27H265.3l-3.11,5.22h-8l17.23-26.88h7.49l6.49,26.88h-7.56Zm-1.15-5.61L273.78,153l-5.14,8.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.34,161.2c0-9.33,6.87-16.12,16.85-16.12,5,0,9,1.8,10.91,5.06l-5.49,4.38a6.55,6.55,0,0,0-5.92-3.15c-5.22,0-8.67,4-8.67,9.33,0,3.61,2.46,6,6.56,6a8.42,8.42,0,0,0,6.57-3.11l4.49,4.41c-3,3.65-7,5-11.79,5C293.6,173,288.34,168.23,288.34,161.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.45,158l9,14.51H334l-6.18-9.68L324.32,166,323,172.49h-7.48l5.37-26.88h7.49l-2.19,11,12.13-11h8.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.46,151.64h-8.25l1.23-6h24.07l-1.23,6h-8.22l-4.18,20.85h-7.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.21,164.42l4.57,8.07h-7.95l-4-7.14H238l-1.42,7.14H229l5.37-26.88h11.48c6.87,0,10.83,3.19,10.83,8.56A10.38,10.38,0,0,1,249.21,164.42Zm-4.45-12.82h-4l-1.61,7.87h4.53c3.34,0,5.3-1.61,5.3-4.57C249,152.64,247.37,151.6,244.76,151.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.74,167.27H265.3l-3.11,5.22h-8l17.23-26.88h7.49l6.49,26.88h-7.56Zm-1.15-5.61L273.78,153l-5.14,8.71Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.34,161.2c0-9.33,6.87-16.12,16.85-16.12,5,0,9,1.8,10.91,5.06l-5.49,4.38a6.55,6.55,0,0,0-5.92-3.15c-5.22,0-8.67,4-8.67,9.33,0,3.61,2.46,6,6.56,6a8.42,8.42,0,0,0,6.57-3.11l4.49,4.41c-3,3.65-7,5-11.79,5C293.6,173,288.34,168.23,288.34,161.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.45,158l9,14.51H334l-6.18-9.68L324.32,166,323,172.49h-7.48l5.37-26.88h7.49l-2.19,11,12.13-11h8.94Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.2,178.94H228c14.17,0,22.82,7.34,22.82,19.11,0,16.13-11.7,26.4-28.41,26.4H199.09Zm14.56,35.24c9.62,0,15-6.64,15-15.35,0-6.05-3.84-9.62-11.25-9.62H219l-4.94,25Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.56,188.88l-1.49,7.67h20.22l-1.89,9.63H269.12l-1.63,8.32h23.86l-2.08,9.95H252.8l9.1-45.51h35.63l-2,9.94Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M313.2,189.14h-14l2.08-10.2h40.77L340,189.14H326.07L319,224.45H306.11Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M368.27,215.61H348.9l-5.27,8.84H330l29.19-45.51h12.68l11,45.51H370.09Zm-1.95-9.5-3.06-14.76-8.71,14.76Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M395.71,178.94h12.87l-9.1,45.51H386.61Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M417.75,178.94h12.87l-7,35.3h21.72l-2.08,10.21H408.65Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M457.41,178.94h12.87l-9.1,45.51H448.31Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M522.69,178.94l-9.1,45.51H503l-15-25-5,25H470.35l9.1-45.51h10.6l15.08,24.9,4.94-24.9Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M558,200.72h11.38l-3.83,19.18a30,30,0,0,1-17.95,5.46c-13.91,0-22.89-8.13-22.89-20,0-15.8,11.64-27.31,28.94-27.31,9.1,0,15.73,2.93,19.83,8.39l-9.24,7.28c-3-3.7-6.5-5-11.18-5-9.36,0-15.34,6.7-15.34,15.8,0,6.11,4.16,10.21,11.64,10.21a16,16,0,0,0,6-1.11Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.5,139.35H59.24v41.26H100.5ZM93.79,173.9H66V146.06H93.79Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 71.82,
    y: 151.93,
    width: 16.1,
    height: 16.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.14,139.35v41.26H162.4V139.35Zm34.55,34.55H127.85V146.06h27.84Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 133.72,
    y: 151.93,
    width: 16.1,
    height: 16.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.24,242.51H100.5V201.25H59.24ZM66,208H93.79V235.8H66Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 71.82,
    y: 213.83,
    width: 16.1,
    height: 16.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.24,
    y: 187.57,
    width: 9.56,
    height: 6.71
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "74.5 187.57 74.5 194.28 107.47 194.28 110.57 194.28 114.18 194.28 114.18 139.35 107.47 139.35 107.47 187.57 74.5 187.57"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 107.47,
    y: 201.25,
    width: 26.42,
    height: 6.71
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "155.69 235.8 133.89 235.8 133.89 242.51 155.69 242.51 162.4 242.51 162.4 235.8 162.4 217.52 155.69 217.52 155.69 235.8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "140.6 224.23 149.32 224.23 149.32 217.52 140.6 217.52 136.07 217.52 133.89 217.52 133.89 228.59 140.6 228.59 140.6 224.23"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "142.61 203.01 149.32 203.01 149.32 187.57 144.62 187.57 142.61 187.57 121.14 187.57 121.14 194.28 142.61 194.28 142.61 203.01"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 38.53,
    y: 187.57,
    width: 144.58,
    height: 6.71
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 155.36,
    y: 201.25,
    width: 7.05,
    height: 6.71
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "117.7 223.22 107.47 223.22 107.47 226.24 107.47 229.93 107.47 242.51 114.18 242.51 114.18 229.93 117.7 229.93 124.41 229.93 124.41 223.22 124.41 217.52 117.7 217.52 117.7 223.22"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "154.85 119.22 154.85 125.93 175.82 125.93 175.82 146.9 182.53 146.9 182.53 119.22 154.85 119.22"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "39.11 146.9 45.82 146.9 45.82 125.93 66.79 125.93 66.79 119.22 39.11 119.22 39.11 146.9"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "66.79 262.64 66.79 255.93 45.82 255.93 45.82 234.96 39.11 234.96 39.11 262.64 66.79 262.64"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "182.53 234.96 175.82 234.96 175.82 255.93 154.85 255.93 154.85 262.64 182.53 262.64 182.53 234.96"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new_logo.0aff9bb992ce2dd81fb91b712347a3e8.svg";
export { ForwardRef as ReactComponent };